module.exports = __webpack_public_path__ + "static/img/fish46.25b5446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish46.png
// module id = 7dJ7
// module chunks = 0